import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonHeader } from '@ionic/react'
import { memberMobx } from '@mobxStore'
import UseCard from '../UseCard'
import { ModalHeader } from '@cps'
import './index.scss'

interface IProps {
  type?: string; // 来源类型 mall 商城
  isPay?: boolean; // 是否来自支付收银台 true 收银台 false 其他购物车等
  reject?: () => void;
  resolve?: (data: any) => void;
}

const Card: FC<IProps> = (props: IProps) => {
  const { resolve, reject, type, isPay } = props
  const cardList = type === 'mall' ? memberMobx.cardListForMall : memberMobx.cardListForPay
  console.log(cardList, 'memberMobx.cardListForPay🪢', type, 'type')
  return (
    <IonModal
      isOpen
      cssClass='switch-card-modal tall-modal height620-modal'
      swipeToClose
      onDidDismiss={reject}
    >
      <ModalHeader title={i18n.t('mkt.member.myCard')} onClose={reject} />
      <IonContent className='modal-content'>
        {
          cardList.length > 0 &&
            <div className='card-list'>
              {
                cardList.map((item: any) => {
                  const disabled = !(type !== 'mall' || (!isPay || (isPay && item.card?.supportMallPay)))
                  return (
                    <div className='card-blcok' key={item.cardId}>
                      <UseCard cardInfo={item} type={type} disabled={disabled} onUse={resolve} />
                      {window.bo !== 'cn' && (!item.card.isPayTip ? (
                        <div className='card-tip'>{i18n.t('pay.memberCardCannotPayTipStar')}</div>
                      ) : (
                        <div className='card-tip'> {i18n.t('pay.memberCardGiveBalanceCannotPayTipStar')}</div>
                      ))}
                    </div>
                  )
                })
              }
            </div>
        }
      </IonContent>
    </IonModal>
  )
}

export default observer(Card)
